module.exports = __webpack_public_path__ + "static/students-parallax-ff4aa81a3a94d5247d86e8280e8ef2ab.jpg";